module.exports = __webpack_public_path__ + "img/stores_virtuell_appointment@2x.27e0df3.jpg";